import { render, staticRenderFns } from "./emailGAConfirm.popup-chunk.vue?vue&type=template&id=4febfaca&scoped=true"
import script from "./emailGAConfirm.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./emailGAConfirm.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./emailGAConfirm.popup-chunk.vue?vue&type=style&index=0&id=4febfaca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4febfaca",
  null
  
)

export default component.exports